import { useEffect } from 'react';

/**
 * @param {React.MutableRefObject<HTMLElement | undefined>} modalRef
 * @param {boolean} enabled
 *
 * @return {void}
 */
export function useFocusTrap(modalRef, enabled) {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const modalElem = modalRef.current;
    if (!modalElem) {
      return;
    }

    const focusableElements = modalElem.querySelectorAll(
      'button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])',
    );
    const firstFocusableElem = focusableElements[0];
    const lastFocusableElem = focusableElements[focusableElements.length - 1];

    /**
     * @param {KeyboardEvent} event
     */
    const handleTabKeyPress = (event) => {
      const isTabKey = event.key === 'Tab';
      const isShifted = event.shiftKey;

      const activeElement = document.activeElement;

      if (!isTabKey) {
        return;
      }

      if (isShifted && activeElement === firstFocusableElem) {
        event.preventDefault();
        lastFocusableElem.focus();
      } else if (!isShifted && activeElement === lastFocusableElem) {
        event.preventDefault();
        firstFocusableElem.focus();
      }
    };

    setTimeout(() => firstFocusableElem?.focus(), 100);

    modalElem.addEventListener('keydown', handleTabKeyPress);

    return () => {
      modalElem.removeEventListener('keydown', handleTabKeyPress);
    };
  }, [enabled, modalRef]);
}
